import React, { useState , useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import star from '../Assets/star.svg'
import arrow from '../Assets/arrow.png'
import { FaFacebookF } from "react-icons/fa";
import {FaInstagram , FaLinkedinIn } from "react-icons/fa6";
import arrowshero from '../Assets/arrowshero.png'
import dinde from '../Assets/herodinde.png'
import nugget from '../Assets/heronugget.png'
import poulet from '../Assets/herochicken.png'
import TypesFood from './TypesFood';
import promo from '../Assets/SVG/promo.svg'
import { Link } from 'react-router-dom';

const Hero = (props) => {
   const { t, i18n } = useTranslation();
    const isRTL = i18n.language === 'ar';

    const [currentIndex, setCurrentIndex] = useState(0);
    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);

    const products = [
      { id: 1, title: t('productpage.productcards.card1.title') , price : '350' , currency : 'Dhs' , unit_with : ' 1KG' , promo : '30%' , pic : dinde },
      { id: 2, title: t('productpage.productcards.card3.title') , price : '350' , currency : 'Dhs' , unit_with : ' 1KG' , promo : '10%'  , pic : poulet },
      { id: 3, title: t('productpage.productcards.card2.title') , price : '350' , currency : 'Dhs' , unit_with : ' 1KG' , promo : '20%'  , pic : nugget },
    ];

    const nextSlide = () => {
      setCurrentIndex((prevIndex) => 
        prevIndex === products.length - 1 ? 0 : prevIndex + 1
      );
    };

    const prevSlide = () => {
      setCurrentIndex((prevIndex) => 
        prevIndex === 0 ? products.length - 1 : prevIndex - 1
      );
    };

    const handleTouchStart = (e) => {
        setTouchStart(e.touches[0].clientX);
    };

    const handleTouchMove = (e) => {
        setTouchEnd(e.touches[0].clientX);
    };

    const handleTouchEnd = () => {
        if (!touchStart || !touchEnd) return;
        
        const distance = touchStart - touchEnd;
        const minSwipeDistance = 50;

        if (Math.abs(distance) >= minSwipeDistance) {
            if (distance > 0) {
                // Swiped left - go to next slide
                nextSlide();
            } else {
                // Swiped right - go to previous slide
                prevSlide();
            }
        }

        setTouchStart(null);
        setTouchEnd(null);
    };
    const [isMob, setIsMob] = useState(false);
    
    // Check the window width and update the isMobile state
      useEffect(() => {
      const handleResize = () => {
        setIsMob(window.innerWidth <= 430);
      };
  
      // Set the initial state
      handleResize();
  
      // Listen for window resize
      window.addEventListener('resize', handleResize);
  
      // Cleanup the event listener
      return () => window.removeEventListener('resize', handleResize);
    }, []);
  return (
    <div name='home' className={`w-full flex flex-col items-center justify-center `}>
      <div className={`w-full  gap-0 sm:gap-8 my-4 sm:my-10  items-center ${props.motherclassName} ${isRTL ? 'rtl' : 'ltr'}`}>
        <div className={` section1 ${props.className2}`}>
          <div className='w-full flex justify-start items-center text-secondary'>
              <img src={arrowshero} alt="arrowshero" className={`h-5 ${isRTL && 'rotate-180'}`}/>
          </div>
          <div className='font-bold '>
            <h1 className={`${props.classText1}  ${!isRTL && 'tracking-[2px] xxxl:tracking-[4px]'} `}>{t('homepage.hero.title.title1')} <span className='text-primary'> {t('homepage.hero.title.title2')}</span></h1>
          </div>
          
          <div className=''>
            <span className={`${props.classText2} text-paragraph`}>{t('homepage.hero.description')}</span>
          </div>
          <div className='w-4/5 flex justify-start items-center bg-primary/80 h-[2px] rounded-full my-6'></div>
          <div className={`${props.cljustify} mb-4`}>
            <div className='flex gap-4 items-center w-full xs:w-[90%] sm:w-[75%] md:w-[85%] xl:w-[75%] xxl:w-[65%]'>
              <img loading="lazy" className={` w-10 h-10 `} src={star} alt='Logo'/>
              <h2 className={`text-paragraph  ${props.classText2}`}> {t('homepage.hero.room1.text1')} <span className='text-primary font-bold'>{t('homepage.hero.room1.text2')}</span> {t('homepage.hero.room1.text3')} <span className="text-primary02 font-bold">{t('homepage.hero.room1.text4')}</span></h2>
            </div>
            <div className='flex gap-4 items-center w-full xs:w-[90%] sm:w-[75%] md:w-[85%] xl:w-[75%] xxl:w-[65%]'>
              <img loading="lazy" className={` w-10 h-10 `} src={star} alt='Logo'/>
              <h2 className={`text-paragraph  ${props.classText2}`}> {t('homepage.hero.room2.text1')} <span className='text-[#008AC1] font-bold'>{t('homepage.hero.room2.text2')}</span> {t('homepage.hero.room2.text3')} <span className="text-black font-bold">{t('homepage.hero.room2.text4')}</span></h2>
            </div>
          </div>
          <div className='socialmedia flex gap-3 sm:gap-4 items-center w-full my-4'>
              <img loading="lazy" className={` h-5 sm:h-6 ${isRTL && 'rotate-180'}`} src={arrow} alt='Logo'/>
              <div className={` rounded-xl flex items-center justify-start gap-3 sm:gap-4`}>
                  <div className=' bg-primary rounded-lg flex items-center justify-center  aspect-square p-2'>
                      <div className='flex items-center justify-center '><FaInstagram size={30} className='text-white'/></div>
                  </div>
                  <div className=' bg-primary rounded-lg flex items-center justify-center  aspect-square p-2'>
                      <div className='flex items-center justify-center '><FaFacebookF size={30} className='text-white'/></div>
                  </div>
                  <div className=' bg-primary rounded-lg flex items-center justify-center  aspect-square p-2'>
                      <div className='flex items-center justify-center '><FaLinkedinIn size={30} className='text-white'/></div>
                  </div>
              </div>
          </div>
        </div>
        {/* if we have the the price of products , make the xxl:h-[520px] , if not make xxl:h-[500px]*/}
        <div className={`${props.className3} h-[330px] xs:h-[380px] sm:h-[450px]  md:h-[550px]  
          ${!props.dis ? 'lg:h-[390px] xl:h-[420px] xxl:h-[500px] xxxl:h-[600px] xxxxl:h-[750px]' : 'lg:h-[600px] '} 
          `}>

          <section className="product relative flex justify-center items-center w-full h-full overflow-hidden  rounded-lg">
            <div className="absolute top-0 left-0 w-[80px] sm:w-[100px] md:w-[150px] h-full bg-gradient-to-r from-white  to-transparent z-10"></div>
            <div className="absolute top-0 right-0  w-[80px] sm:w-[100px] md:w-[150px] h-full bg-gradient-to-l from-white  to-transparent z-10"></div>
            {/* if we have the the price of products , run this code in the bottom */}
            {/* <button 
              onClick={prevSlide} 
              className={`absolute  ${!props.dis 
                ? 'lg:left-[96px] xl:left-[100px] xxl:left-[134px] xxxl:left-[160px] xxxxl:left-[205px] h-12 w-8 xl:h-16 xl:w-10 xxxl:h-20' 
                : 'h-12 w-6 sm:h-16 sm:w-10 left-[32px] xs:left-[43px] sm:left-[112px] md:left-[145px] lg:left-[160px]'} 
                z-20  bg-primary  lg:bg-gray-200 lg:hover:bg-primary  rounded-full transition-all duration-300 group flex items-center justify-center`}
              aria-label="Previous slide"
            >
              <IoIosArrowBack size={35} className="text-secondary lg:text-primary lg:group-hover:text-secondary animate-pulse" />
            </button>
            
            <div 
                className="relative w-full h-full"
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
            >
              {products.map((product, index) => {
                // Calculate the position relative to current index
                let position = index - currentIndex;
                if (position < 0) position += products.length;
                
                return (
                  <Link to={`/products?product=${product.id}`} smooth duration={500}
                    key={product.id}
                    className={`text-center absolute transition-all duration-1000 transform w-[70%] aspect-[9/16] ${
                      index === currentIndex 
                        ? 'z-10  scale-100 left-1/2 -translate-x-1/2  h-[100%]' 
                      : index === (currentIndex + 1) % products.length
                        ? 'z-5 scale-75 -right-6 sm:right-0 translate-x-1/2 h-[65%] sm:h-[85%]'
                      : index === (currentIndex - 1 + products.length) % products.length
                        ? 'z-5  scale-75 -left-6 sm:left-0 -translate-x-1/2  h-[65%] sm:h-[85%]'
                      : 'opacity-0 scale-50 translate-x-full h-[65%] sm:h-[85%] '
                    }`}
                    style={{
                      top: '50%',
                      transform: `translateY(-50%) ${
                        index === currentIndex 
                          ? 'translateX(-50%)' 
                          : index === (currentIndex + 1) % products.length
                            ? 'translateX(50%)'
                            : index === (currentIndex - 1 + products.length) % products.length
                              ? 'translateX(-50%)'
                              : 'translateX(100%)'
                      }`
                    }}
                  >
                    <div className="w-full h-full relative flex justify-center">
                      <div className='w-full h-[90%] p-4  transition-all duration-500 relative'>
                        <div className={`absolute 
                          sm:w-[120px]  md:w-[130px]  ${!props.dis ? 'lg:w-[100px] xl:w-[110px] xxl:w-[120px] xxxl:w-[150px] xxxxl:w-[180px]' : 'lg:w-[150px] '}
                          ${isMob ? 'top-8 xs:top-12 left-1/2 translate-x-5 xs:translate-x-7  w-[80px]' : 'top-6 left-1/2 -translate-x-1/2 xs:translate-x-6 sm:translate-x-8 md:translate-x-14 xs:w-[100px]'}
                          ${!props.dis && 'top-8 xxxl:top-10 left-1/2 lg:translate-x-6 xxl:translate-x-10 xxxxl:translate-x-16'}
                           z-10 aspect-square transition-all duration-500 ${index === currentIndex ? 'opacity-100 animate-pulse' : 'opacity-0'}`}>
                          <span className='absolute z-[21]  font-bold left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col'>
                            <span className={`text-primary ${isMob ? 'text-[25px] ' : 'xs:text-[30px]'}  sm:text-[35px]  md:text-[38px]  ${!props.dis ? 'lg:text-[30px] xl:text-[35px] xxl:text-[38px] xxxl:text-[40px] xxxxl:text-[45px]' : 'lg:text-[40px] '}`}>{product.promo}</span>
                            <span className={`text-secondary ${isMob ? 'text-[20px]' : 'xs:text-[25px]'}   sm:text-[30px]  md:text-[33px]  ${!props.dis ? 'lg:text-[25px] xl:text-[30px] xxl:text-[32px] xxxl:text-[35px] xxxxl:text-[45px]' : 'lg:text-[35px] '}`}>OFF</span> 
                          </span>
                          <img src={promo} alt='promo' 
                          className={`w-full z-[1] relative aspect-square object-contain`}/>
                        </div>
                        <img 
                          loading="lazy"
                          src={product.pic} 
                          alt={product.name}
                          className={`w-full h-full object-contain`}
                        />
                      </div>
                      <h1 className={`absolute  bottom-1 z-[100] text-primary02 !font-bold flex flex-col items-center justify-center h-[10%] my-0 ${index === currentIndex ? 'opacity-100 w-full' : 'opacity-0'}`}>
                        <span className={`text-primary ${props.classText12}`}>{product.price}.{product.currency},{product.unit_with}</span>
                      </h1>
                    </div>
                  </Link>
                );
              })}
            </div>

            <button 
              onClick={nextSlide} 
              className={`absolute  ${!props.dis 
                ? 'lg:right-[96px] xl:right-[100px] xxl:right-[134px] xxxl:right-[160px] xxxxl:right-[205px] h-12 w-8 xl:h-16 xl:w-10 xxxl:h-20' 
                : 'h-12 w-6 sm:h-16 sm:w-10 right-[32px] xs:right-[43px] sm:right-[112px] md:right-[145px] lg:right-[160px]'} 
                z-20  bg-primary  lg:bg-gray-200 lg:hover:bg-primary  rounded-full transition-all duration-300 group flex items-center justify-center`}
              aria-label="Next slide"
            >
              <IoIosArrowForward size={35} className="text-secondary lg:text-primary lg:group-hover:text-secondary animate-pulse" />
            </button> */}

            {/* if we don't have any price of products run this code in the bottom */}
            <button 
              onClick={prevSlide} 
              className={`absolute  ${!props.dis 
                ? 'lg:left-[93px] xl:left-[100px] xxl:left-[128px] xxxl:left-[157px] xxxxl:left-[203px] h-12 w-8 xl:h-16 xl:w-10 xxl:w-8 xxxl:w-10 xxxl:h-20' 
                : 'h-12 w-6 sm:h-16 sm:w-10  left-[27px] xs:left-[38px] sm:left-[109px] md:left-[140px] lg:left-[157px]'} 
                z-20  bg-primary  lg:bg-gray-200 lg:hover:bg-primary  rounded-full transition-all duration-300 group flex items-center justify-center`}
              aria-label="Previous slide"
            >
              <IoIosArrowBack size={35} className="text-secondary lg:text-primary lg:group-hover:text-secondary animate-pulse" />
            </button>
            
            <div 
                className="relative w-full h-full"
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
            >
              {products.map((product, index) => {
                // Calculate the position relative to current index
                let position = index - currentIndex;
                if (position < 0) position += products.length;
                
                return (
                  <Link to={`/products?product=${product.id}`} smooth duration={500}
                    key={product.id}
                    className={`text-center absolute transition-all duration-1000 transform w-[70%] aspect-[9/16] ${
                      index === currentIndex 
                        ? 'z-10  scale-100 left-1/2 -translate-x-1/2  h-[100%]' 
                      : index === (currentIndex + 1) % products.length
                        ? 'z-5 scale-75 -right-6 sm:right-0 translate-x-1/2 h-[55%] sm:h-[75%]'
                      : index === (currentIndex - 1 + products.length) % products.length
                        ? 'z-5  scale-75 -left-6 sm:left-0 -translate-x-1/2  h-[55%] sm:h-[75%]'
                      : 'opacity-0 scale-50 translate-x-full h-[55%] sm:h-[75%] '
                    }`}
                    style={{
                      top: '50%',
                      transform: `translateY(-50%) ${
                        index === currentIndex 
                          ? 'translateX(-50%)' 
                          : index === (currentIndex + 1) % products.length
                            ? 'translateX(50%)'
                            : index === (currentIndex - 1 + products.length) % products.length
                              ? 'translateX(-50%)'
                              : 'translateX(100%)'
                      }`
                    }}
                  >
                    <div className="w-full h-full relative flex justify-center">
                      <div className='w-full h-[100%] p-4  transition-all duration-500 relative'>
                        <img 
                          loading="lazy"
                          src={product.pic} 
                          alt={product.name}
                          className={`w-full h-full object-contain`}
                        />
                      </div>

                    </div>
                  </Link>
                );
              })}
            </div>

            <button 
              onClick={nextSlide} 
              className={`absolute  ${!props.dis 
                ? 'lg:right-[93px] xl:right-[100px] xxl:right-[128px] xxxl:right-[157px] xxxxl:right-[203px] h-12 w-8 xl:h-16 xl:w-10 xxl:w-8 xxxl:w-10 xxxl:h-20' 
                : 'h-12 w-6 sm:h-16 sm:w-10 right-[27px] xs:right-[38px] sm:right-[109px] md:right-[140px] lg:right-[157px]'} 
                z-20  bg-primary  lg:bg-gray-200 lg:hover:bg-primary  rounded-full transition-all duration-300 group flex items-center justify-center`}
              aria-label="Next slide"
            >
              <IoIosArrowForward size={35} className="text-secondary lg:text-primary lg:group-hover:text-secondary animate-pulse" />
            </button>
          </section>
        </div>
      </div>
      <TypesFood />
    </div>
  )
}

export default Hero